import { FAMILIES } from "./familiesConfig";

export const segmentTitle = (segment) => {
  const family = FAMILIES.find((entry) => entry.key === segment.family_key);

  return {
    title: segment.family_key ? segment.label || segment.name : segment.name,
    family: family ? family.label : null,
  };
};
